export default __webpack_public_path__ + "static/media/close.d39e9848.svg";